/* istanbul ignore file */
import { fetchTopBannerContent } from '@noths/polaris-client-banners';
import type { FeatureFlags } from '@noths/polaris-client-feature-flags';
import { fetchNavigationContent, GlobalNavigation } from '@noths/polaris-client-site-chrome-ui';
import type { Config, StackName } from '@noths/polaris-server-content-fetching';
import { Environment, fetchContentByQuery } from '@noths/polaris-server-content-fetching';
import * as runtimeProcess from 'process';

import { DEVELOPMENT, QA } from 'src/constants/environment';
import type { ContentstackSections, ContentstackSeo } from 'src/types/Contentstack';
import type { PageConfiguration, PageMetadata } from 'src/types/PageProps';
import { logger } from 'src/utils/serverLogger';

/** @deprecated content should be moved to the DX stack */
export const getContentstackEnvironment = (isPreview?: boolean) => {
  if (isPreview) {
    return Environment.Preview;
  }
  const isQa = runtimeProcess.env.ENV_TYPE === QA || process.env.NODE_ENV === DEVELOPMENT;

  return isQa ? Environment.Qa : Environment.Production;
};

export const getContentstackDXEnvironment = (isPreview?: boolean) => {
  return isPreview ? Environment.Preview : Environment.Production;
};

export interface RibbonsPageContentEntry {
  category_id?: string;
  sections: ContentstackSections[];
  seo: ContentstackSeo;
  title: string;
}

export interface DXPageContentEntry {
  modular_content: ContentstackSections[];
  seo: {
    canonical_url_override: string;
    description: string;
    indexable: boolean;
    title_override: string;
  };
  title: string;
}

interface GlobalContentOptions {
  featureFlags: FeatureFlags;
  isPreview?: boolean;
  urlPath?: string;
}

export const fetchGlobalContent = async ({
  featureFlags,
  isPreview = false,
  urlPath,
}: GlobalContentOptions) => {
  const env = getContentstackEnvironment(isPreview);
  const config = { env, logger };
  const navContentVariantId = featureFlags.nav_content_experiment;
  const contentSource =
    featureFlags[GlobalNavigation.NAME] === GlobalNavigation.PROGRESSIVE_DISCLOSURE
      ? 'dx'
      : 'legacy';

  return Promise.all([
    fetchNavigationContent(config, navContentVariantId, contentSource).catch(() => null),
    fetchTopBannerContent(config, urlPath),
  ]);
};

export const fetchPageContentByQuery = async (
  { contentType }: PageConfiguration,
  { isPreview, pathname }: PageMetadata,
) => {
  // TODO: remove feature switch
  const isDXStack = true;
  const stackName: StackName = isDXStack ? 'DX' : 'Ribbons';
  const config: Config = {
    env: isDXStack
      ? getContentstackDXEnvironment(isPreview)
      : getContentstackEnvironment(isPreview),
    logger,
    stackName,
  };

  const data = await fetchContentByQuery(config, contentType, { url: pathname });

  if (isDXStack) {
    return data.content as DXPageContentEntry;
  }

  return data.content as RibbonsPageContentEntry;
};
